// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__3z+wH","auth":"modal_auth__c05aQ","change_password":"modal_change_password__YUgsL","btns":"modal_btns__RzO4o"};